<template>
  <div>
<!--    销售顾问列表-->
    <x-grid
        :id="'formList'"
        :rowId="rowId"
        :pager-config="pagerConfig"
        :form-config="formConfig"
        :url="url"
        :columns="columns"
        :checkbox-config="checkboxConfig"
        :toolbar-config="toolbarConfig"
        :print-config="printConfig"
        :import-config="importConfig"
        :export-config="exportConfig"
        ref="grid"
        :cellClick="chooseRow"
        :cellDbClick="updateRow"
        @toolbar-addData="addRow"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>
      </template>
    </x-grid>

    <a-space class="a-form-btn-box">
      <a-button @click="closeAssignPop()">取消</a-button>
      <a-button type="primary" @click="getAssignPopResult">提交</a-button>
    </a-space>

  </div>
</template>

<script>
import {
  GridMixin,
  api,
  fac,
} from "@/utils/common/XGridBase";
import {dataApi} from '@/services/clue/clueManage.js';

//列表接口 -  获取人员经销商下人员信息
const url = api.clue.CLUEPOOL + '/selectUsersSalePage';

//主键
const rowId = 'userId';

//列
const columns = [
  fac.makeColumnRadioDefault(),
  // fac.makeColumnCheckboxDefault(),
  fac.makeColumn("deptName", "经销商"),
  fac.makeColumn("userNo", "用户编号"),
  fac.makeColumn("userName", "用户名称"),
  fac.makeColumn("mobile", "手机号码"),
]

//筛选项
const formConfig = fac.makeFormConfig(columns, [
  {field: 'deptName'},
  {field: 'userName'},
  {field: 'mobile'},
])

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  import: false,
  export: false,
  delData: false,
  addData: false,
  templatelSlots: 'toolbarBtns'
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);

async function loadBaseData() {

}

export default {
  mixins: [GridMixin],
  // props: ['assignIdArr'],
  props: {
    assignIdArr: {
      type: Array,
      default: () => []
    }
  },
  components: {},
  data() {
    return {
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
    }
  },
  async mounted() {
    // let that = this;
    // setInterval(()=>{
    //   console.log(that.$refs['grid'].$refs['xGrid'].getFormItems())
    // },1000)
  },
  methods: {
    loadBaseData,
    /**
     * 提交数据 分配
     * @param entities
     * @param vm
     * @returns {Promise}
     */
    async getAssignPopResult() {
      let userId = this.$refs['grid'].$refs['xGrid'].getRadioRecord();
      if(!userId){
        this.$message.error('请选择一条数据');
        return false;
      }
      let result = {
        userId: userId.userId,
        idList: this.assignIdArr.join(',')
      }
      this.loading(true);
      let entity = await dataApi.getPoolAssign(result);
      if(entity.code === 200){
        this.loading(false);
        this.$emit('close');
      }
    },
    // 取消 关闭弹窗
    closeAssignPop(){
      this.$emit('close');
    }
  }
}
</script>

<style scoped>

/deep/ .vxe-table--body-wrapper {
  height: 300px !important;
}

/deep/ .vxe-table--empty-placeholder {
  height: 300px !important;
}

</style>